import React from 'react';
import { Tabs, Tab } from '../../components/Tabs';
import BackBtn from '../../components/UI/BackBtn';
import Page from '../../components/_layout/Page';
import ProgramBuysList from './tabsAccounting/ProgramBuysList';
import PlanBudgetMeetings from './tabsAccounting/PlanBudgetMeetings';

import '../Project.less';
import { isAdmin } from '../../services/rolesSvc';
import useUserContext from '../../hooks/useUserContext';

const styledHeading = { marginLeft: 0, marginBottom: 24, marginTop: 24 };

export default function BudgetAccounting() {
  const userCtx = useUserContext();

  const tabs = [
    { label: 'program-buys-list', tabName: 'Реестр закупок программы', content: <ProgramBuysList /> },
    {
      label: 'plan-meetings', tabName: 'Планирование заседаний', content: <PlanBudgetMeetings />, show: (user) => isAdmin(user),
    },
  ];

  return (
    <Page className="project-page">
      <BackBtn />
      <h3 style={styledHeading}>Оперативная комиссия</h3>
      <div style={{ marginTop: 20 }}>
        <Tabs>
          {tabs
            .filter((t) => !t.show || t.show(userCtx))
            .map((tab, i) => (
              <Tab key={i} label={tab.label} tabName={tab.tabName}>
                {tab.content}
              </Tab>
            ))}
        </Tabs>
      </div>
    </Page>
  );
}
